import type { ReduxState } from '@/redux/app/state';

export const userSettingsSelector = (state: ReduxState) =>
  state.settings.user;

export const accountSettingsSelector = (state: ReduxState) =>
  state.settings.account;

export const inboxIsPausedSelector = (state: ReduxState) =>
  userSettingsSelector(state)?.pauseInbox;

export const inboxTogglePauseStatusSelector = (state: ReduxState) =>
  userSettingsSelector(state)?.inboxTogglePauseStatus;

export const inboxCompactModeSelector = (state: ReduxState) =>
  userSettingsSelector(state)?.compactTickets;

export const inboxToggleCompactModeStatusSelector = (state: ReduxState) =>
  userSettingsSelector(state)?.inboxToggleCompactModeStatus;

export const accountHidePauseButtonSelector = (state: ReduxState) =>
  accountSettingsSelector(state)?.hidePauseButton;

export const accountSoloConversationsEnabledSelector = (state: ReduxState) =>
  accountSettingsSelector(state)?.privateTickets;

export const accountManagerSeesAllTicketsSelector = (state: ReduxState) =>
  accountSettingsSelector(state)?.noPrivateManager;

export const accountPrivateConversationsEnabledSelector = (state: ReduxState) =>
  accountSettingsSelector(state)?.onlyOwnedTickets;

export const embeddedVarsEnabledSelector = (state: ReduxState) =>
  userSettingsSelector(state)?.embeddedVarsEnabled;

export const templateHotkeysEnabledSelector = (state: ReduxState) =>
  userSettingsSelector(state)?.templateHotkeysEnabled;

export const spellcheckEnabledSelector = (state: ReduxState) =>
  userSettingsSelector(state)?.spellcheckEnabled;

export const quickChatEnabledSelector = (state: ReduxState) =>
  userSettingsSelector(state)?.quickChatEnabled;

export const quickChatValueSelector = (state: ReduxState) =>
  userSettingsSelector(state)?.quickChatValue;
